const initLanguageMenu = function () {
	const $langMenu = $('.pll-parent-menu-item');
	const $subMenu = $('.pll-parent-menu-item .sub-menu');

	if ($langMenu.length) {
		$langMenu.on('click', function () {
			$(this).toggleClass('active');
		});

		/* Anything that gets to the document will hide the dropdown */
		$(document).on('click', function (e) {
			if ($langMenu.hasClass('active')) {
				if (!$(e.target).closest($langMenu).length) {
					$langMenu.removeClass('active');
				}
			}
		});
	}
};

export default initLanguageMenu;